import { defineQuery } from '@rocicorp/zero';
import * as z from 'zod';
import { zql } from '../schema.js';
import { applyCursor } from '../util/apply-cursor.js';
import { Cursor, Sort } from './util.js';
import { Status } from '../util/schemas.js';
export const PharmaciesFilters = z.object({
    name: z.string().optional(),
    status: z.array(Status).optional(),
});
export const ListPharmaciesInput = z.object({
    cursor: Cursor.extend({
        createdAt: z.number(),
        name: z.string(),
    }).optional(),
    sort: Sort.extend({
        field: z.enum(['createdAt', 'name']),
    }),
    limit: z.number().optional(),
    filters: PharmaciesFilters.optional(),
});
export const pharmaciesQueries = {
    listPharmacies: defineQuery(ListPharmaciesInput, params => {
        const input = params.args;
        let q = zql.pharmacies.where('deletedAt', 'IS', null);
        if (input.filters?.name?.trim()) {
            const searchTerm = `%${input.filters.name.trim()}%`;
            q = q.where(({ cmp }) => cmp('name', 'ILIKE', searchTerm));
        }
        q = applyCursor(q, { cursor: input.cursor, sort: input.sort, limit: input.limit });
        return q;
    }),
    getAllPharmacies: defineQuery(_params => {
        return zql.pharmacies.where('id', 'IS NOT', null).where('deletedAt', 'IS', null);
    }),
    getPharmacyById: defineQuery(z.string(), params => {
        return zql.pharmacies
            .related('location')
            .related('created')
            .related('address')
            .related('deliveryAddress')
            .related('productionLocations', q => q.where('deletedAt', 'IS', null))
            .where('id', '=', params.args)
            .where('deletedAt', 'IS', null)
            .one();
    }),
    getPharmacyActivitiesById: defineQuery(z.string(), params => {
        return zql.eventLogs
            .related('actor')
            .where('resource', '=', 'pharmacy')
            .where('resourceId', '=', params.args)
            .orderBy('performedAt', 'desc');
    }),
    getAllProductionLocations: defineQuery(_params => {
        return zql.productionLocations.where('deletedAt', 'IS', null);
    }),
};
//# sourceMappingURL=pharmacies.queries.js.map